"use client";

import { useState } from "react";
import Modal from "./Modal";
import NavList from "./NavList";
import Icon from "./Icon";

// Hamburger (mobile) → navigation modal.
export default function MobileNav() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        onClick={() => setOpen(true)}
        aria-label="Open menu"
        className="neu-btn lg:hidden grid place-items-center w-12 h-12 rounded-2xl text-text-muted shrink-0"
      >
        <Icon name="grid" size={19} />
      </button>

      <Modal open={open} onClose={() => setOpen(false)} size="sm">
        <div className="flex flex-col gap-1.5 min-h-[60dvh]">
          <NavList onNavigate={() => setOpen(false)} />
        </div>
      </Modal>
    </>
  );
}
